export enum DEVICES {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
